import { render } from "./BoqQuotationAttachedItems.vue?vue&type=template&id=600f2ef0&scoped=true"
import script from "./BoqQuotationAttachedItems.vue?vue&type=script&lang=js"
export * from "./BoqQuotationAttachedItems.vue?vue&type=script&lang=js"

import "./BoqQuotationAttachedItems.vue?vue&type=style&index=0&id=600f2ef0&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600f2ef0"]])

export default __exports__